const mediaQueryMatches = mediaQuery => window.matchMedia(`(${mediaQuery})`).matches;
export default mediaQueryMatches;
//# sourceMappingURL=viewport.js.map